import fetchConfig from "./fetchConfig";
import handleResponse from "./handleFetchResponse";

const clientConfigApiDomain = process.env.REACT_APP_CLIENT_CONFIG_API_DOMAIN;
const aggregateCountRpcUrl = `${clientConfigApiDomain}/rpc/aggregate_counts`;
const recordCountRpcUrl = `${clientConfigApiDomain}/rpc/record_counts`;
const identitySpecCountRpcUrl = `${clientConfigApiDomain}/rpc/identity_spec_counts`;
const callCountsSummaryUrl = `${clientConfigApiDomain}/rpc/call_counts/client_summary`;
const systemNotificationsUrl = `${clientConfigApiDomain}/system_notifications`;

export const fetchAggregateCountData = async id => {
  const fetchAggregateCountDataResponse = await fetch(
    `${aggregateCountRpcUrl}/?client_id=${id}`
  );
  const fetchAggregateCountDataResponseData = await fetchAggregateCountDataResponse.json();

  return fetchAggregateCountDataResponseData;
};

export const fetchReviewQueueCountData = async id => {
  const url =
    process.env.NODE_ENV === "development"
      ? "/assignedRQCount.json"
      : `${clientConfigApiDomain}/rpc/review_queue_counts/?client_id=${id}`;

  const fetchReviewQueueCountDataResponse = await fetch(url);
  const fetchReviewQueueCountDataResponseData = await fetchReviewQueueCountDataResponse.json();

  return fetchReviewQueueCountDataResponseData;
};

export const fetchBulkOrgData = async id => {
  const mockUrl = `/bulkOrgData.json`;
  const fetchBulkOrgResponse = await fetch(
    ...fetchConfig(
      `${clientConfigApiDomain}/rpc/organization_bulk/?clients__oid=${id}`,
      mockUrl
    )
  );
  const fetchBulkOrgResponseData = await fetchBulkOrgResponse.json();
  return fetchBulkOrgResponseData;
};

export const fetchClientSubscriptionsData = async id => {
  const mockUrl = `/clientSubscriptionsData.json`;
  const fetchClientSubscriptionsResponse = await fetch(
    ...fetchConfig(
      `${clientConfigApiDomain}/client_subscriptions/?client__oid=${id}`,
      mockUrl
    )
  );
  const fetchClientSubscriptionsResponseData = await fetchClientSubscriptionsResponse.json();
  return fetchClientSubscriptionsResponseData;
};

export const fetchRecordCountData = async id => {
  const fetchRecordResponse = await fetch(
    `${recordCountRpcUrl}/?client_id=${id}`
  );
  const fetchRecordResponseData = await fetchRecordResponse.json();

  return fetchRecordResponseData;
};

export const fetchAPICallCountsSummary = async oid => {
  const fetchCallCountsResponse = await fetch(
    `${callCountsSummaryUrl}/?client_oid=${oid}`
  );
  const fetchCallCountsResponseData = await fetchCallCountsResponse.json();

  return fetchCallCountsResponseData;
};

export const fetchIdentitySpecCountData = async id => {
  const fetchIdentitySpecResponse = await fetch(
    `${identitySpecCountRpcUrl}/?client_id=${id}`
  );
  const fetchIdentitySpecResponseData = await fetchIdentitySpecResponse.json();

  return fetchIdentitySpecResponseData;
};

export const fetchSystemNotificationData = async currentDate => {
  const fetchSystemNotificationResponse = await fetch(
    `${systemNotificationsUrl}/?start_date__lte=${currentDate}&end_date__gte=${currentDate}`
  );
  if (fetchSystemNotificationResponse.status === 200) {
    const fetchSystemNotificationResponseData = await fetchSystemNotificationResponse.json();
    return fetchSystemNotificationResponseData;
  } else {
    return [];
  }
};

export const aggregatesCall = async (
  overlayRecordId,
  overlayRecordSourceSystem,
  user
) => {
  let risk_score = "";
  let gid = "";
  const risk_score_url =
    "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/imdm/#eiia-risk-score";
  const aggregates_url = `${process.env.REACT_APP_CLIENT_IDENTITY_SERVICE_DOMAIN}/patient/aggregates`;
  const aggregates_mockUrl = `/fhirPatients.json`;
  const aggregates_config = {
    method: "POST",
    body: JSON.stringify({
      ids: [{ value: overlayRecordId }],
      sourceId: overlayRecordSourceSystem
    }),
    credentials: "include",
    headers: {
      clientId: user.preferences.selectedClient.oid,
      "Content-Type": "application/json"
    }
  };
  return fetch(
    ...fetchConfig(aggregates_url, aggregates_mockUrl, aggregates_config)
  )
    .then(handleResponse)
    .then(res => {
      if (res.data) {
        gid = res.data[0].id;
        if (res.data[0].extension) {
          for (let i = 0; i < res.data[0].extension.length; i++) {
            if (res.data[0].extension[i].url === risk_score_url) {
              risk_score = res.data[0].extension[i].valueString;
              return { gid, risk_score };
            }
          }
        }
      }
      return { gid, risk_score };
    })
    .catch(error => {
      return { gid, risk_score };
    });
};
